export default "__VITE_ASSET__DZeyd4mW__"